var map = {
	"./亞克力烤漆UV.jpg": 617,
	"./內光刀刮布.jpg": 4879,
	"./啞面刀刮布.jpg": 8755,
	"./磨砂玻璃貼紙UV.jpg": 1228,
	"./窗簾布UV.jpg": 2557,
	"./超透玻璃貼紙UV.jpg": 6038,
	"./透明玻璃貼紙UV.jpg": 1366,
	"./電動帆布簾.jpg": 6271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9098;